import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-godown-reports',
  templateUrl: './godown-reports.component.html',
  styleUrls: ['./godown-reports.component.css']
})
export class GodownReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

  

}



// WEBPACK FOOTER //
// ./src/app/Godown/godown-reports/godown-reports.component.ts